import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Countdown, CustomTimelineVersion, OtpResentMode } from '../../model/kamonal-model';
import { KamonaOtpVersion } from '../kamona-otp/kamona-otp.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { ModalOptionsConfig, ModalService } from '../../../lean-shared/components/nz-modal-service/modal.service';
import {
  MobileKamonaResentOtpModalComponent,
} from '../../components/kamona-resent-otp-modal/partials/mobile-kamona-resent-otp-modal/mobile-kamona-resent-otp-modal.component';
import { AppConfig } from '../../../shared/config/app-config';
import { ResendOtpModalConfig } from './model/kamona-otp-widget.model';
import { logger } from '@mpt-fo/common/telemetry';

@Component({
  selector: 'ng-mf-kamona-otp-widget',
  templateUrl: './kamona-otp-widget.component.html',
  styleUrls: ['./kamona-otp-widget.component.scss']
})
export class KamonaOtpWidgetComponent implements OnInit {
	@Input() noOfPin = 6;
	@Output() emitBack = new EventEmitter ();
	@Output() emitReload = new EventEmitter ();
	@Output() emitSubmit = new EventEmitter ();
	@Output() help = new EventEmitter ();
	@Input() usesHelpButton: boolean;
	@Input() description: string;
	@Input() version =  CustomTimelineVersion.version_8;
	@Input() title: string;
	@Input() hideBackBtn = false;
	@Input() minHeight = 510;
	@Input() submitting: boolean;
	@Input() currentStep: number;
	@Input() totalStep: number;
	@Input() previousTitle: string;
	@Input() btnText = 'Next';
	@Input() currentOtpMode = OtpResentMode.SMS_MODE;
	@Input() ussd: any;
	@Input() phoneNumber: string;
	@Input() startCountdown = true;
	@Input() canUseWhatsappOTPResend: boolean;
	@Input() canUseNewUssd: boolean;
	@Input() useCustomMobileStepper = false;
	@Input() hasResendButtonCountdown = false;
	@Input() showBothCountDown = false;
	otp: string;
	canUseUssdOTPResend = true;
	@Input() canUseSmsOTPResend = true;
	loading = true;
	readonly CustomTimelineVersion = CustomTimelineVersion;
	readonly KamonaOtpVersion = KamonaOtpVersion;
	readonly DEFAULT_COUNTDOWN_TIME = 10;
	defaultWhatsappCountdownTime = 2;
  readonly DEFAULT_SMS_COUNTDOWN: Countdown = {minute: 10, second: 0};
  defaultWhatsappCountdown: Countdown = {minute: 2, second: 0};
	smsCountdown: Countdown;
	readonly defaultCountdown: Countdown = {minute: 0, second: 0};
  whatsappCountdown: Countdown;
	runningModal: NzModalRef;
  resendOptionCounter = 0;
	resendButtonCountDown: Countdown = { minute: 0, second: 45 }
	showResendButtonCountDown = false;
	canUseNewResendOtpUi = false

	constructor(private modalService: ModalService, private appConfig: AppConfig) { }

  ngOnInit(): void {
    console.log(' ngOnInit KamonaOtpWidgetComponent ---> ');
  }

	submit(){
	  if(this.submitting){return;}
	  const otp = this.otp;
	  this.emitSubmit.emit({otp});
	}

	initialize(){
    this.setOTPDefaultCountDownValue();
		this.canUseNewResendOtpUi = this.hasResendButtonCountdown && this.appConfig.OTP_RESEND_V2;
		if(this.canUseNewResendOtpUi){
			this.startResendButtonCountdown()
		}
		if(!this.startCountdown){return;}
    if (this.showBothCountDown) {
      this.startSmsCountdown();
      this.startWhatsappCountdown();
      return;
    }
    (this.isSmsOtpMode()) ? this.startSmsCountdown() : this.startWhatsappCountdown();
	}

  setOTPDefaultCountDownValue() {
    const value = this.appConfig.WHATSPP_OTP_COUNTDOWN_IN_SECONDS || 60;
    const result = this.convertSecondsToMinutesSeconds(value);
    this.defaultWhatsappCountdownTime = this.convertSecondsToMinutes(value);
    this.defaultWhatsappCountdown = { minute: result.minutes, second: result.seconds };
  }

  convertSecondsToMinutesSeconds(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return { minutes, seconds };
  }

  convertSecondsToMinutes(totalSeconds) {
    return totalSeconds / 60;
  }

  isSmsOtpMode(){
    return this.currentOtpMode === OtpResentMode.SMS_MODE;
  }

	setOtp($event: string){
		this.otp = $event;
	}

	goBack(){
	  if(this.submitting){return;}
	  this.emitBack.emit();
	}

	handleOtpAction(){
		const params = this.getResendOtpModalPayload();
    this.updateResendOptionCounter();
		this.launchModal(params, MobileKamonaResentOtpModalComponent);
	}

	updateResendOptionCounter(){
		this.resendOptionCounter += 1;
	}

	getResendOtpModalPayload() : ResendOtpModalConfig{
		return {
      smsCountdown: this.smsCountdown,
			ussdCode: this.ussd,
			canUseWhatsappOTPResend: this.canUseWhatsappOTPResend,
			phoneNumber: this.phoneNumber,
			canStartCountdown: this.resendOptionCounter > 0,
      currentMode: this.currentOtpMode,
			canUseNewUssd: this.canUseNewUssd,
      whatsappCountdown: this.whatsappCountdown,
			canUseResendOptV2: this.canUseNewResendOtpUi,
			showBothCountDown: this.showBothCountDown,
			canUseSmsOTPResend: this.canUseSmsOTPResend
		}
	}

	launchModal(params: any, component: any) {
		const config = this.createModalConfig(params);
		this.runningModal = this.modalService.createModal(component, config);
	}

	createModalConfig(params: any) {
		const config = new ModalOptionsConfig();
		config.nzComponentParams.data = params;
		config.nzMaskClosable = true;
		config.className = this.getModalClassName();
		config.nzComponentParams.callback = (res: any) => {
			this.handleModalResponse(res);
		};
		return config;
	}

	handleModalResponse({countdown, currentMode}){
    this.currentOtpMode = currentMode;
    if(currentMode !== OtpResentMode.USSD_MODE)
      this.updateCountdown(countdown)
		this.emitReload.emit(currentMode);
		this.runningModal.destroy();
	}

  updateCountdown(countdown: Countdown){
    if(this.isSmsOtpMode()){
      this.smsCountdown = countdown ?? this.DEFAULT_SMS_COUNTDOWN ;
      return;
    }
    this.whatsappCountdown = countdown ?? this.defaultWhatsappCountdown;
  }


	getModalClassName(){
		return 'moniepoint-dialog';
	}

	startSmsCountdown() {
		const min = this.smsCountdown?.minute;
		const sec = this.smsCountdown?.second;
		const totalMinutes = (sec / 60) + min;
		const startMinutes = totalMinutes || this.DEFAULT_COUNTDOWN_TIME;
		let time = startMinutes * 60;
		const t = setInterval(() => {
			const minute = this.getMinutes(time);
			const second = this.getSeconds(time);
			this.smsCountdown = {minute, second};
			time--;
			if (this.isCountdownExpire(this.smsCountdown)) {
				clearInterval(t);
			}
		}, 1000);
	}

  isCountdownExpire(countdown: Countdown){
    if(!countdown){return true}
    return countdown?.minute === 0 && countdown?.second === 0;
  }

  startWhatsappCountdown() {
    const min = this.whatsappCountdown?.minute;
    const sec = this.whatsappCountdown?.second;
    const totalMinutes = (sec / 60) + min;
    const startMinutes = totalMinutes || this.defaultWhatsappCountdownTime;
    let time = startMinutes * 60;
    const t = setInterval(() => {
      const minute = this.getMinutes(time);
      const second = this.getSeconds(time);
      this.whatsappCountdown = {minute, second};
      time--;
      if (this.isCountdownExpire(this.whatsappCountdown)) {
        clearInterval(t);
      }
    }, 1000);
  }

  startResendButtonCountdown() {
    const min = this.resendButtonCountDown.minute;
    let sec = this.resendButtonCountDown.second;
	this.showResendButtonCountDown = true;

    const t = setInterval(() => {
      const minute = this.getMinutes(sec);
      const second = this.getSeconds(sec);
      this.resendButtonCountDown = {minute, second};
      sec--;
      if (this.isCountdownExpire(this.resendButtonCountDown)) {
		this.showResendButtonCountDown = false;
        clearInterval(t);
      }
    }, 1000);
  }

	getSeconds(time: number) {
		return Math.floor(time % 60);
	}

	getMinutes(time: number) {
		return Math.floor(time / 60);
	}

	formatTime = (t: number) => {
		return t < 10 ? '0' + t : t;
	  }

}
